<template>
  <div class="home">
    <Header></Header>
    <section class="home-body">
      <article class="article-container bg-white">
        <div class="box-center">
          <el-row :gutter="36" type="flex" justify="space-between" align="middle">
            <el-col
              :span="10"
              style="text-align: left"
              ><img :src="Introduction" alt=""
            /></el-col>
            <el-col :span="14">
              <p>
                Introduction to Engineering for Electronic Information (Class B)
                is a basic compulsory course for undergraduates majoring in power
                IEEE honor classes. This course is targeted at first-year students
                at the School of Electronic Information and Electrical
                Engineering. Through the study of this course, students will have
                a more complete and systematic understanding of the development of
                electrical engineering, and then clarify the future learning goals
                and efforts to lay the foundation for subsequent professional
                courses.
              </p>
              <p>
                Introduction to Engineering for Electronic Information (Class B)
                mainly introduces the four parts in electrical engineering
                development, including crawler & database, text retrieval, data
                visualization, and website platform development. This lesson helps
                students to know the problems need to be solved, basic methods to
                solve the problems, and the team communication during the
                engineering development process. Based on the current domestic and
                international situation, introduce the challenges faced by
                engineering development, stimulate students 'creative potential,
                and cultivate students' ability to find and solve problems. And
                let students understand the whole process of project development
                and management in the actual group project development, improve
                professional ability, improve team collaboration & communication
                ability, and improve
              </p>
            </el-col>
          </el-row>
        </div>
      </article>
      <article class="article-container bg-gray">
        <div class="box-center">
          <h2>Instructors</h2>
          <el-row :gutter="36">
            <el-col
              :span="12"
              >
              <el-row :gutter="32" type="flex" justify="center" align="middle">
                <el-col :span="12" style="text-align: right">
                    <img :src="T1" alt=""/>
                </el-col>
                <el-col :span="12">
                  <div class="t-info">
                    <h3>Xinbing Wang (王新兵)</h3>
                    <div class="info">Instructor of IEEI, Professor</div>
                    <div class="info">Professor Department of Computer Science and Engineering </div>
                    <div class="info"><br/></div>
                    <div class="info"><span class="label">Room:</span> SEIEE-1-439</div>
                    <div class="info"><span class="label">Email:</span> xwang8@sjtu.edu.cn</div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col
              :span="12"
              >
              <el-row :gutter="32" type="flex" justify="center" align="middle">
                <el-col :span="12" style="text-align: right">
                    <img :src="T2" alt=""/>
                </el-col>
                <el-col :span="12">
                  <div class="t-info">
                    <h3>Gui'e Meng (孟桂娥)</h3>
                    <div class="info">Lecturer</div>
                    <div class="info">Department of Electronic Engineering </div>
                    <div class="info"><br/></div>
                    <div class="info"><span class="label">Room:</span> SEIEE-1-434</div>
                    <div class="info"><span class="label">Email:</span> gemeng@sjtu.edu.cn</div>
                  </div>
                </el-col>
              </el-row>
              </el-col>
          </el-row>
        </div>
      </article>
      <article class="article-container bg-white ta-container">
        <div class="box-center">
          <h2>Teaching Assistants</h2>
          <el-row :gutter="36">
            <el-col
              :xs="12"
              :sm="8"
              :md="6"
              :lg="6"
              :xl="6"
              style="text-align: center"
              >
              <div>
                <h4>Haiwen Wang (王海文) </h4>
                <div class="ta-info">TA, Graduate </div>
                <div class="ta-info">Email:wanghaiwen@sjtu.edu.cn</div>
              </div>
            </el-col>
            <el-col
              :xs="12"
              :sm="8"
              :md="6"
              :lg="6"
              :xl="6"
              style="text-align: center"
              >
              <div>
                <h4>Bin Lu (卢彬) </h4>
                <div class="ta-info">TA, Graduate </div>
                <div class="ta-info">Email:robinlu1209@sjtu.edu.cn</div>
              </div>
            </el-col>
            <el-col
              :xs="12"
              :sm="8"
              :md="6"
              :lg="6"
              :xl="6"
              style="text-align: center"
              >
              <div>
                <h4>Shao Zhang (张劭)</h4>
                <div class="ta-info">TA, Graduate </div>
                <div class="ta-info">Email:shaozhang@sjtu.edu.cn</div>
              </div>
            </el-col>
            <el-col
              :xs="12"
              :sm="8"
              :md="6"
              :lg="6"
              :xl="6"
              style="text-align: center"
              >
              <div>
                <h4>Hui Xu (徐辉)</h4>
                <div class="ta-info">TA, Graduate </div>
                <div class="ta-info">Email:xhui_1@sjtu.edu.cn</div>
              </div>
            </el-col>
            <el-col
              :xs="12"
              :sm="8"
              :md="6"
              :lg="6"
              :xl="6"
              style="text-align: center"
              >
              <div>
                <h4>Junjie Ou (欧俊杰)</h4>
                <div class="ta-info">TA, Graduate </div>
                <div class="ta-info">Email:j_michael@sjtu.edu.cn</div>
              </div>
            </el-col>
            <el-col
              :xs="12"
              :sm="8"
              :md="6"
              :lg="6"
              :xl="6"
              style="text-align: center"
              >
              <div>
                <h4>Cheng Deng (邓程)</h4>
                <div class="ta-info">TA, Graduate </div>
                <div class="ta-info">Email:davendw@sjtu.edu.cn</div>
              </div>
            </el-col>
            <el-col
              :xs="12"
              :sm="8"
              :md="6"
              :lg="6"
              :xl="6"
              style="text-align: center"
              >
              <div>
                <h4>Qi Li (李琦)</h4>
                <div class="ta-info">TA, Graduate </div>
                <div class="ta-info">Email:liqilcn@sjtu.edu.cn</div>
              </div>
            </el-col>
            <el-col
              :xs="12"
              :sm="8"
              :md="6"
              :lg="6"
              :xl="6"
              style="text-align: center"
              >
              <div>
                <h4>Jiexing Qi (亓杰星)</h4>
                <div class="ta-info">TA, Graduate </div>
                <div class="ta-info">Email:qi_jiexing@sjtu.edu.cn </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </article>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Introduction from "@/assets/home/Introduction.svg";
import T1 from "@/assets/home/T1.png";
import T2 from "@/assets/home/T2.png";
export default {
  name: "Home",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      Introduction: Introduction,
      T1,
      T2,
    };
  },
};
</script>
<style lang="less" scoped>
.article-container {
  padding: 54px 0;
  .box-center {
    width: 1420px;
    margin: auto;
  }
  p {
    text-align: left;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #000;
  }
  h2 {
    font-weight: 900;
    font-size: 32px;
    line-height: 24px;
    margin-bottom: 48px;
  }
  h3 {
    text-align: left;
    font-size: 24px;
    line-height: 24px;
    font-weight: 700;
    margin-bottom: 8px;
  }
  .info {
    text-align: left;
    font-size: 16px;
    line-height: 24px;
  }
  .label {
    font-weight: 700;
  }
  .ta-info {
    font-size: 18px;
    line-height: 24px;
    text-align: center;
  }
  h4 {
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 4px;
  }
}
.ta-container {
  .el-col {
    margin-bottom: 36px;
  }
}
.bg-white {
  background: #fff;
}
.bg-gray {
  background: #f4f4f4;
}
</style>
